import DataTable from "common/Tables/DataTable";
import DashboardLayout from "common/LayoutContainers/DashboardLayout";
import shiftRequetsData from "layouts/tables/data/shiftRequetsData";
import DashboardNavbar from "common/Navbars/DashboardNavbar";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { Card, Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { getAllShiftRequets } from "store/slice/shiftsSlice";

const DealerRequestHistory = () => {
    const shiftStore = useSelector(store => store.shift);
    const shiftRequets = shiftStore?.shiftRequets;
    const dispatch = useDispatch();

    const editAction = () => {}
    const { columns, rows } = shiftRequetsData({
        shiftRequets,
        editAction,
    });

    useEffect(() => {
        dispatch(getAllShiftRequets())
    }, [])

    return (<DashboardLayout>
                <DashboardNavbar />
                <MDBox pt={6} pb={3}>
                    <Grid container spacing={6}>
                        <Grid item size={{ xs: 12 }}>
                            <Card>
                            <MDBox
                                mx={2}
                                mt={-3}
                                py={3}
                                px={2}
                                variant="gradient"
                                bgColor="info"
                                borderRadius="lg"
                                coloredShadow="info"
                                display="flex"
                                justifyContent="space-between"
                                alignItems="center"
                            >
                                <MDTypography variant="h6" color="white">
                                Request History
                                </MDTypography>
                            </MDBox>
                            <MDBox pt={3}>
                                <DataTable
                                table={{ columns, rows }}
                                isSorted={false}
                                entriesPerPage={false}
                                showTotalEntries={false}
                                noEndBorder
                                />
                            </MDBox>
                            </Card>
                        </Grid>
                    </Grid>
                </MDBox>
        </DashboardLayout>
    )
}


export default DealerRequestHistory;